<template>
  <div></div>
</template>
<script>
export default {
  name: 'Terminated',
  mounted() {
    document.body.className = 'terminated'
    document.title = 'Page not found'

    const favicon = document.getElementById('favicon')
    favicon.href = 'http://www.google.com/favicon.ico'
  }
}
</script>
